// client/src/App.js
import { Container } from 'react-bootstrap';
import { Outlet, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Landing from './tabs/Portifolio';
import TopProjects from './components/TopProjects';
import Experience from './components/Experience';
import About from './components/About';
import GamingPortfolio from './tabs/GamingPortfolio';
import AboutMe from './tabs/AboutMe';
import HubWebsite from './tabs/HubWebsite';
import Projects from './tabs/Projects';
import BlogPage from './tabs/BlogPage';
import Services from './tabs/Services';
import NfcReviews from './tabs/NfcReviews';
import NfcSupport from './tabs/NfcSupport';
import MenuDemo from './tabs/MenuDemo';
import MenuQrCode from './tabs/MenuQrCode';
import PasswordGenerator from './tabs/PasswordGenerator';
import Home from './tabs/HomePage';

import Loader from './components/Loader';

import './App.css';

function Layout() {
  return (
    <Container fluid className="m-0 p-0">
      <Outlet />
    </Container>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/top-projects" element={<TopProjects />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/gaming-portfolio" element={<GamingPortfolio />} />
          <Route path="/about-me" element={<AboutMe />} />
          <Route path="/hub" element={<HubWebsite />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/portifolio" element={<Landing />} />
          <Route path="/services" element={<Services />} />
          <Route path="/nfc-reviews" element={<NfcReviews />} />
          <Route path="/nfc-support" element={<NfcSupport />} />
          <Route path="/menu-demo" element={<MenuDemo />} />
          <Route path="/menu-demo/qr" element={<MenuQrCode />} />
          <Route path="/password-generator" element={<PasswordGenerator />} />
        </Route>
      </Routes>
  );
}

export default App;
